// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"1a34c6c7","448":"fc38ae06"}[chunkId] + ".css";
};